import {ChangeDetectionStrategy, Component, Input, Output, EventEmitter} from '@angular/core';
import {AbstractControl, FormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {Team} from 'src/app/teams/shared/model/team';
import {User} from 'src/app/core/model/user';
import {SkillModel} from 'src/app/core/model/skill';
import {ProjectTaskDialogPanels} from '../project-task-dialog-constants';
import {TaskDialogDetailsPanelRewardsComponent} from './rewards/task-dialog-details-panel-rewards.component';
import {OphCheckboxComponent} from 'src/app/shared/design/oph-checkbox/oph-checkbox.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {CommonModule} from '@angular/common';
import {TaskDurationSliderComponent} from '../../duration-slider/task-duration-slider.component';
import {TaskPrioritySelectorComponent} from '../../priority-selector/task-priority-selector.component';
import {ProvisionsSelectorComponent} from '../../provisions-selector/provisions-selector.component';

@Component({
  selector: 'projects-task-details',
  standalone: true,
  imports: [
    CommonModule,
    TaskDurationSliderComponent,
    TaskPrioritySelectorComponent,
    ProvisionsSelectorComponent,
    TaskDialogDetailsPanelRewardsComponent,
    AsyncPipe,
    OphCheckboxComponent,
    MatTooltipModule,
  ],
  templateUrl: './projects-task-details.component.html',
  styleUrl: './projects-task-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsTaskDetailsComponent {
  @Input() form!: FormGroup;
  @Input() teamsMap$!: Observable<Record<string, Team>>;
  @Input() usersMap$!: Observable<Record<string, User>>;
  @Input() skillsMap$!: Observable<Record<string, SkillModel>>;
  @Input() newTask: boolean = false;
  @Input() isTemplate: boolean = false;

  @Output() panelChange = new EventEmitter<ProjectTaskDialogPanels>();

  ProjectTaskDialogPanels = ProjectTaskDialogPanels;

  onChangePanel(panel: ProjectTaskDialogPanels) {
    this.panelChange.emit(panel);
  }

  get scheduleControl(): AbstractControl {
    return this.form.get('schedule');
  }
}
